/** Regions where sidebar multi-select should stay active (tree itself + agentic chat). */
export const PROJECT_TREE_SELECTION_PRESERVE_SELECTORS = [
  "#draggable-root",
  "[data-agentic-chat-panel='true']",
] as const;

export function shouldPreserveProjectTreeSelection(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return PROJECT_TREE_SELECTION_PRESERVE_SELECTORS.some((selector) => target.closest(selector));
}
